export interface IRestaurantPhone {
  PhoneDescription?: string;
  PhoneExtension: string;
  RestaurantId?: number;
  RestaurantNumber?: number;
  RestaurantPhoneNumber: string;
  RestaurantPhoneNumberId?: number;
  RestaurantPhoneType: string;
  RestaurantPhoneTypeId: number;
}

export interface IRestaurantEmail {
  RestaurantEmail: string;
  RestaurantEmailDescription?: string;
  RestaurantEmailId?: number;
  RestaurantEmailType: string;
  RestaurantEmailTypeId: number;
  RestaurantId?: number;
  RestaurantNumber?: number;
}

export enum OPERATION_TYPES {
  ADD = 'add',
  UPDATE = 'update',
  DELETE = 'delete',
}

interface IRestaurantEmailAndPhoneBase {
  operation: OPERATION_TYPES;
  id: string | number | null;
  type: string | number;
}
export interface IRestaurantPhoneEdit extends IRestaurantEmailAndPhoneBase {
  number: string;
  extension: string;
}
export interface IRestaurantEmailEdit extends IRestaurantEmailAndPhoneBase {
  value: string;
}

export interface IRestaurant {
  RestaurantId: string | number;
  FranchiseGroup?: string;
  RestaurantStatus: string;
  RestaurantNumber?: string;
  RestaurantAddressLine1: string;
  RestaurantAddressLine2: string;
  RestaurantAddressCity?: string;
  customer_facing_address_addressLine1: string;
  physical_address_address_line1: string;
  Landmark: string;
  Crosstreet: string;
  TimeZone?: string;
  Latitude?: string;
  Longitude?: string;
  Region?: string;
  Country?: string;
  City?: string;
  'State/Province'?: string;
  emails: IRestaurantEmail[];
  phones: IRestaurantPhone[];
  DoesHomeDelivery: string;
  HasCurbsidePickups: string;
  HasCurbsideSpots: string;
  HasDigitalKiosk: string;
  HasDineIn: string;
  HasDriveThru: string;
  HasDigitalDriveThru: string;
  HasFullMenu: string;
  HasLateNightMenu: string;
  HasMobileOrdering: string;
  HasODMB: string;
  HasSuggestiveSell: string;
  HasTakeOut: string;
  HasWIFI: string;
  ServesBreakfast: string;
}

export interface IRestaurantEdit {
  restaurantId: string | number;
  restaurantStatus: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  landmark: string;
  streetCornerLocation: string;
  emails: IRestaurantEmailEdit[];
  phones: IRestaurantPhoneEdit[];
  doesHomeDelivery: string;
  hasCurbsidePickups: string;
  hasCurbsideSpots: string;
  hasDigitalKiosk: string;
  hasDineIn: string;
  hasDriveThru: string;
  hasDigitalDriveThru: string;
  hasFullMenu: string;
  hasLateNightMenu: string;
  hasMobileOrdering: string;
  hasODMB: string;
  hasSuggestiveSell: string;
  hasTakeOut: string;
  hasWIFI: string;
  servesBreakfast: string;
}

// TODO: change interface when the Services data gets retrived from and endpoint
export interface IRestaurantService {
  restaurantKey: string;
  name: string;
}
